import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProhibitedItemsAcknowledgment.css';

export default function ProhibitedItemsAcknowledgment({ isOpen, onClose, onConfirm }) {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="prohibited-items-dialog">
                <h2>{t('prohibitedItems.title')}</h2>
                <p className="prohibited-items-warning">{t('prohibitedItems.warning')}</p>

                <ul className="prohibited-items-list">
                    <li>{t('prohibitedItems.items.highValue')}</li>
                    <li>{t('prohibitedItems.items.flammable')}</li>
                    <li>{t('prohibitedItems.items.dirty')}</li>
                    <li>{t('prohibitedItems.items.dangerous')}</li>
                    <li>{t('prohibitedItems.items.financial')}</li>
                    <li>{t('prohibitedItems.items.notEasilyReproduced')}</li>
                    <li>{t('prohibitedItems.items.notReproducible')}</li>
                    <li>{t('prohibitedItems.items.personalInfo')}</li>
                </ul>

                <p className="prohibited-items-confirmation">{t('prohibitedItems.confirmation')}</p>

                <div className="dialog-buttons">
                    <button className="cancel-button" onClick={onClose}>
                        {t('common.buttons.cancel')}
                    </button>
                    <button className="confirm-button" onClick={onConfirm}>
                        {t('prohibitedItems.acknowledge')}
                    </button>
                </div>
            </div>
        </div>
    );
}
